import React, { useCallback, useEffect, useState } from "react";
import DocLists from "../sections/standards/DocLists";
import PageContainer from "../components/PageContainer";
import { getStandardRegularData } from "../api/standard";

const bgImg = "/images/standards/bg-standards.jpeg";

const defailtDocGroups = [
  {
    title:
      "แนวปฏิบัติการรักษาความมั่นคงปลอดภัยเว็บไซต์ (Website Security Guideline)",
    file: "/documents/standards/NCSA.pdf",
    type: "pdf",
  },
  {
    title:
      "(ร่าง) แบบประเมินสถานภาพการดำเนินงานด้านการรักษาความมั่นคงปลอดภัยไซเบอร์",
    file: "/documents/standards/NIST.pdf",
    type: "pdf",
  },
];

const Policy = () => {
  const [docGroups] = useState(defailtDocGroups);

  const [pageData, setPageData] = useState(null);

  const getData = useCallback(
    () =>
      getStandardRegularData()
        .then((res) => setPageData(res))
        .catch((err) => console.log(err)),
    [setPageData]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  console.log(
    "pageData",
    pageData?.docgroup.flatMap((doc) => doc.docitem)
  );

  return (
    <PageContainer
      title={pageData?.title ?? "ข้อบังคับระเบียบและประกาศสำนักงาน"}
    >
      <section>
        <div className="container mx-auto mt-[-50px] max-w-[800px]">
          <div className="card bg-white shadow-xl mx-auto">
            <div className="card-body min-h-[800px]">
              <div className="card-title bg-[#E9EAF8] justify-center p-2 text-black">
                {pageData?.title ?? "ข้อบังคับระเบียบและประกาศสำนักงาน"}
              </div>
              <DocLists
                docs={pageData?.docgroup.flatMap((doc) => doc.docitem) ?? []}
                keyLabel="doctitle"
                bgColor="#fff"
              />
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
};

export default Policy;
